import { SectionStyleField } from "../section-style.fields";

const ContentBlockFields = {
  heading: {
    type: "text",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading (e.g. 'About Us', 'Our Mission')",
      seo: true,
      key: "content.heading",
    },
  },
  content: {
    type: "textarea",
    label: "Content",
    metadata: {
      source: "ai",
      description: "Main content text (2-3 paragraphs)",
      seo: true,
      key: "content.body",
    },
  },
  imageUrl: {
    type: "custom",
    label: "Image",
    metadata: {
      source: "manual", // User selects from image library or uploads
      description: "URL for a relevant image",
      seo: false,
    },
  },
  imageAlt: {
    type: "text",
    label: "Image Alt Text",
    metadata: {
      source: "manual", // User provides alt text for accessibility/SEO
      description: "Descriptive alt text for the image",
      seo: true,
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Image Left, Text Right", value: "image-left" },
      { label: "Image Right, Text Left", value: "image-right" },
      { label: "Centered (No Image or Image Above)", value: "centered" },
      { label: "Text Only (No Image)", value: "no-image" },
      { label: "Statement (Big Heading Left, Text Right)", value: "statement" },
    ],
    metadata: {
      source: "manual",
    },
  },
  imageStyle: {
    type: "radio",
    label: "Image Style",
    options: [
      { label: "Shadow", value: "shadow" },
      { label: "Border", value: "border" },
      { label: "None", value: "none" },
    ],
    metadata: {
      source: "manual",
      description: "Framing around the image. Choose None for logos and marks.",
    },
  },
  imageSize: {
    type: "number",
    label: "Image size",
    min: 20,
    max: 100,
    step: 5,
    metadata: {
      source: "manual",
      default: 50,
      description: "How much of the row the image takes beside the text, or how wide it is when centred.",
    },
  },
  imageColor: {
    type: "radio",
    label: "Image Color",
    options: [
      { label: "As uploaded", value: "original" },
      { label: "White", value: "white" },
    ],
    metadata: {
      source: "manual",
      description: "White turns a one-colour logo white, for a brand-colour background.",
    },
  },
  backgroundColor: {
    type: "radio",
    label: "Background Color",
    options: [
      { label: "White", value: "white" },
      { label: "Light Gray", value: "gray" },
      { label: "Primary Tint", value: "primary" },
      { label: "Brand color", value: "brand" },
    ],
    metadata: {
      source: "manual",
    },
  },
  headingSize: {
    type: "radio",
    label: "Heading Size",
    options: [
      { label: "Large", value: "large" },
      { label: "Medium", value: "medium" },
      { label: "Small", value: "small" },
    ],
    metadata: {
      source: "manual",
    },
  },
  // Bold sets the heading in display capitals; its size is the style.
  variant: SectionStyleField,
} as const;

export { ContentBlockFields };
